import { useOrganizationStore } from "@/lib/zustand/useStore";
import { OrganizationTypeWordingResolverProps } from ".";

export function OrganizationTypeWordingResolver({ plural, capitalize }: Readonly<OrganizationTypeWordingResolverProps>) {
    const { organization } = useOrganizationStore()
    let wordPerOrganizationType = organization?.organization_type === 'user' ? 'user' : 'project';
    wordPerOrganizationType = plural ? `${wordPerOrganizationType}s` : wordPerOrganizationType;
    wordPerOrganizationType = capitalize ? capitalizeFirstLetter(wordPerOrganizationType) : wordPerOrganizationType;
    return (
        <>
            {wordPerOrganizationType}
        </>
    );
}

const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}